import React from 'react'

const DEFAULT_HEIGHT = 5
const DEFAULT_FILL_TOKEN = '--color-primary-100'
const BACKGROUND_DEFAULT_FILL_TOKEN = '--color-neutral-100'


export const ProgressBar = ({
    progress,
    height = DEFAULT_HEIGHT,
    fill = DEFAULT_FILL_TOKEN,
    backgroundFill = BACKGROUND_DEFAULT_FILL_TOKEN,
    ...props
  }) => (
    <div
      data-ds-component="DS-ProgressBar"
      aria-label={`${progress}%`}
      width="100%"
      style={
        {
          'background-color': `var(${backgroundFill})`,
          'height': `${height}px`,
        }
      }
      {...props}
    >
      <div
        style={
          {
            'height': '100%',
            'width': `${progress}%`,
            'background-color': `var(${fill})`,
            'transition': 'width 3 ease-in-out',
          }
        }
      />
    </div>
  )
  